import { FollowUpAppointmentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

export function useFollowUpAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, dto, workOrderId }: { id: number; dto: FollowUpAppointmentDto; workOrderId?: string }) => {
      const { data } = await appointmentApi.followUp(id, dto);
      // `data` is the appointment plus the sign-off's own flag; the flag is lifted out so a caller
      // that only wants the Termin keeps getting a plain `Appointment`.
      const { followUpAlreadyPlanned, ...appointment } = data;
      return { appointment, workOrderId, followUpAlreadyPlanned };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // See `useCompleteAppointment` — the calendar's copy of this Termin lives under scheduleKeys.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
